import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Document from '../../entities/document';
import Firm from '../../entities/firm';
import Identification from '../../entities/identification';

/*
 * Delete/nullify anywhere this document is used in other entities
 *
 * @param {Document} document
 */
export function deleteDocument(document: Document, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = document.id;
    }
    /* Simple delete usages */
        
    store.getState().firms
        .getMappingFor('documentId', document.id)
        .filter(firmTemp => firmTemp.status !== 'D')
        .forEach(firmTemp => {
            const _firm = firmTemp.clone();
            _firm.status =  'U';
            _firm.addedOn = newHRTimestamp();
            _firm.addedBy = getCurrentUserId();
            _firm.importSource = targetImportSource;
            _firm.importId = mergeId;

            _firm.logo = null;
            store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
        });

    store.getState().identifications
        .getMappingFor('documentId', document.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.attachments = _identification.attachments?.filter(id => id !== document.id) || [];
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    /* Remove the actual document */
    document.status = 'D';
    document.addedOn = newHRTimestamp();
    document.addedBy = getCurrentUserId();
    document.importSource = targetImportSource;
    document.importId = mergeId;
    store.dispatch(Actions.DocumentActions.removeDocumentQueue(document));
    
}

/*
 * Replace anywhere this document is used in other entities.
 *
 * @param {Document} document
 * @param {Document} replaceWith
 * @return {Document} - Document will have refs stripped away
 */
export function replaceDocument(document: Document, replaceWith: Document, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = document.id;
    }
    /* Simple replace usages */
        
    store.getState().firms
        .getMappingFor('documentId', document.id)
        .filter(firmTemp => firmTemp.status !== 'D')
        .forEach(firmTemp => {
            const _firm = firmTemp.clone();
            _firm.status =  'U';
            _firm.addedOn = newHRTimestamp();
            _firm.addedBy = getCurrentUserId();
            _firm.importSource = targetImportSource;
            _firm.importId = mergeId;

            _firm.logo = replaceWith.id;
            store.dispatch(Actions.FirmActions.saveFirmQueue(_firm));
        });

    store.getState().identifications
        .getMappingFor('documentId', document.id)
        .filter(identificationTemp => identificationTemp.status !== 'D')
        .forEach(identificationTemp => {
            const _identification = identificationTemp.clone();
            _identification.status =  'U';
            _identification.addedOn = newHRTimestamp();
            _identification.importSource = targetImportSource;
            _identification.importId = mergeId;

            _identification.attachments = _identification.attachments?.map(id => (id === document.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.IdentificationActions.saveIdentificationQueue(_identification));
        });

    return document;
}

/*
 * Determine the impact of deleting this document from other entities
 *
 * @param {Document} document
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactDocument(document: Document) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const firmLogoImpact = state.firms
          .getMappingFor('documentId', document.id)
          .filter(firm => firm.status !== 'D');

    firmLogoImpact.forEach(() => impacts.push('firms'));

    const identificationAttachmentsImpact = state.identifications
          .getMappingFor('documentId', document.id)
          .filter(identification => identification.status !== 'D');

    identificationAttachmentsImpact.forEach(() => impacts.push('identifications'));

    return util.countDistinct(impacts);
}